module.exports = __webpack_public_path__ + "static/media/hw_so_15.74edd79f.flv";